import React from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { polyglot } from '../../../index'
import { checkSelected } from '../../../resources/utilities'
import './style.css'

class Checkbox extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      options: props.options,
      selectedOptions: undefined
    }
  }

  componentWillMount () {
    const options = this.props.options
    const selected = []
    Object.keys(options).forEach(key => {
      const d = this.props.savedData
      if (checkSelected(d, options[key].value)) {
        selected.push(options[key].value)
      }
    })
    this.setState({
      selectedOptions: selected
    })
  }

  handleChange (key, e) {
    const name = e.target.name
    const value = e.target.checked

    if (value) {
      const updated = this.state.selectedOptions || []
      updated.push(e.target.value)
      this.setState({
        selectedOptions: updated
      }, this.props.getFieldValue(key, updated))
    } else {
      const index = this.state.selectedOptions.indexOf(e.target.name)
      const updated = update(this.state.selectedOptions, {$splice: [[index, 1]]})
      this.setState({
        selectedOptions: updated
      }, this.props.getFieldValue(key, updated))
    }
    this.setState({
      [name]: value
    })
  }

  render () {
    return <div className='form-group'>
      <label className='col-sm-6 control-label'>{polyglot.t(this.props.label)}</label>
      <div className='col-sm-6'>
        <div>
          {this.state.options
            ? this.state.options.map((element, index) => {
              return <div key={index} className='checkbox'>
                <label>
                  <input type='checkbox' checked={checkSelected(this.state.selectedOptions, element.value)}
                    onChange={(e) => this.handleChange(this.props.name, e)} name={element.value} value={element.value} /> {polyglot.t(element.label)}
                </label>
              </div>
            })
            : null
          }
        </div>
      </div>
    </div>
  }
}

Checkbox.propTypes = {
  label: PropTypes.string,
  addon: PropTypes.string,
  options: PropTypes.array.isRequired,
  getFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  savedData: PropTypes.array,
  parentName: PropTypes.string,
  visibleValues: PropTypes.array
}

Checkbox.defaultProps = {
  required: false
}

export {Checkbox}



// WEBPACK FOOTER //
// ./src/components/common/Checkbox/Checkbox.js